export default __webpack_public_path__ + "static/minh-screenshot-dbb3507c33d9e7f95028414ec0c2b542.jpg";